import styled from 'styled-components';
import colors from 'styles/colors';
import { Tag } from 'styles/common';
import VehicleIcon from 'assets/AgreementIcons/Vehicle';

import { LargeSelectorChildren } from 'styles/form';

export const OdometerOptionNumber = styled.div`
  & > svg {
    margin-right: 5px;
  }
`;

export const OdometerOptions = styled.div`
  display: flex;
  margin-bottom: 16px;

  & > div:nth-child(2) {
    margin-left: 10px;
  }

  & p,
  ${OdometerOptionNumber} {
    font-weight: 600;
    font-size: 12px;
  }

  & ${LargeSelectorChildren} > div {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const OdometerOptionLabel = styled.div`
  display: flex;
  align-items: center;
  line-height: 19px;

  & > svg {
    margin-right: 5px;
  }

  & > ${Tag} {
    margin-left: 5px;
  }
`;
